import * as React from 'react';
export const atomeSvg = React.forwardRef(function atomeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16 14h-2.87l-1.636-2.675c-1.091.733-2.235 1.107-3.415 1.107h-.14c-1.286-.034-2.43-.494-3.398-1.141L2.87 14H0L7.991 1l3.08 5.01s-.387.323-.844.63c-.335.221-1.11.698-1.778-.222l-.458-.733L5.81 9.246c.668.46 1.425.784 2.182.801 1.32.034 2.658-.818 3.996-2.504h2.992a16.43 16.43 0 0 1-1.637 2.18L16 14Z',
    }),
  );
});
atomeSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var atome = {
  category: 'paymentmethod',
  colorable: true,
  name: 'atome',
  svg: atomeSvg,
};
